<template>
	<div v-if="!window.PHP.bot && galas.length" class="only-mobile text-xs bg-zt-light/35 p-3 rounded-zt mb-8 mt-3">
		<div class="pb-[15px]">
			<span class="text-zt-more font-semibold uppercase">Najbliższe gale</span>
		</div>
		<div v-for="(gala, index) in galas" :key="gala.id" class="flex flex-col w-full">
			<div class="flex w-full border-dashed border-zt-light" :class="{ 'border-b' : index !== galas.length - 1 }">
				<div class="w-[65%] border-r border-zt-light py-2">
					<a :href="gala.is_ended !== '0' || gala.status === 'IP' ? gala.result_link.length > 0 ? gala.result_link : gala.gala_link : gala.gala_link"
						 class="no-default-style underline zt-hover">
						{{ gala.is_ended === '0' && gala.status !== 'IP' ? 'Karta walk' : 'Wyniki' }} {{ gala.name }}
					</a>
				</div>
				<div class="w-[35%] py-2 flex items-center uppercase justify-end">
					<span v-if="gala.is_ended === '0' && gala.status !== 'IP'" class="text-zt-more">{{ this.formatDate(gala.month) }} | {{ gala.hour || 'TBA' }}</span>
					<span v-else class="text-zt-more ">Zakończono</span>
				</div>
			</div>
		</div>
		<div class="w-full flex justify-center pt-[19px] pb-[6px]">
			<a href="/sporty-walk/"
				 class="no-default-style zt-hover text-zt-red border border-zt-red rounded-zt uppercase py-[5px] px-[15px]">
				Zakładka sporty walki
			</a>
		</div>
	</div>
</template>

<script>

export default {
	name: 'UpcomingGalas',
	inject: ['WP'],
	data() {
		return {
			galas: []
		}
	},
	mounted() {
		axios
			.post(this.WP.ajaxUrl, {
			endpoint: 'api_get_galas_for_upcoming_galas_shortcode'
			})
			.then(response => {
				this.galas = response.data.data;
			})
	},
	methods: {
		formatDate(date, hour) {
			const eventDate = DateTime.fromFormat(date, 'dd-MM-yyyy');
			return eventDate.toFormat('d MMM');
		}
	}
}

</script>